import { apiRequest } from '@/plugins/api.js';
import { apiResponseTypeEnum } from '@/constants/api.js';
import { achievementCategoryEnum } from '@/constants/reward.js';

export const apiRequestNewPin = ({ queryParams }) => apiRequest({
  url: 'api/requestNewPin',
  method: 'GET',
  params: queryParams,
}).then((response) => {
  const responseEnum = response?.data?.responseEnum;
  const responseData = response?.data?.data;

  if (responseEnum !== apiResponseTypeEnum.OPERATION_SUCCESS) {
    return Promise.reject({ responseEnum });
  } else if (!responseData) {
    return Promise.reject({ responseEnum: 'EMPTY_DATA' });
  }

  return { parsedData: responseData };
});

export const apiVerifyPinForForgotPassword = ({ queryParams }) => apiRequest({
  url: 'api/verifyPinForForgotPassword',
  method: 'GET',
  params: queryParams,
}).then((response) => {
  const responseEnum = response?.data?.responseEnum;
  const responseData = response?.data?.data;

  if (responseEnum !== apiResponseTypeEnum.OPERATION_SUCCESS) {
    return Promise.reject({ responseEnum });
  } else if (!responseData) {
    return Promise.reject({ responseEnum: 'EMPTY_DATA' });
  }

  return { parsedData: responseData };
});

export const apiResetPassword = ({ payload }) => apiRequest({
  url: 'api/resetUserPassword',
  method: 'POST',
  data: payload,
}).then((response) => {
  const responseEnum = response?.data?.responseEnum;

  if (responseEnum !== apiResponseTypeEnum.OPERATION_SUCCESS) {
    return Promise.reject({ responseEnum });
  }
});

export const apiHEUserRegister = ({ queryParams }) => apiRequest({
  url: 'api/heRegister',
  method: 'GET',
  params: queryParams,
}).then((response) => {
  const responseEnum = response?.data?.responseEnum;
  const responseData = response?.data?.data;

  if (responseEnum !== apiResponseTypeEnum.OPERATION_SUCCESS) {
    return Promise.reject({ responseEnum });
  } else if (!responseData) {
    return Promise.reject({ responseEnum: 'EMPTY_DATA' });
  }

  return { parsedData: responseData };
});

export const apiGetUserStatus = ({ queryParams }) => apiRequest({
  url: 'api/getStatus',
  method: 'GET',
  params: queryParams,
}).then((response) => {
  const responseEnum = response?.data?.responseEnum;
  const responseData = response?.data?.data;

  if (responseEnum !== apiResponseTypeEnum.OPERATION_SUCCESS) {
    return Promise.reject({ responseEnum });
  } else if (!responseData) {
    return Promise.reject({ responseEnum: 'EMPTY_DATA' });
  }

  return { parsedData: responseData };
});

export const apiSubscribeUser = ({ queryParams }) => apiRequest({
  url: 'api/subscribeUser',
  method: 'GET',
  params: queryParams,
}).then((response) => {
  const responseEnum = response?.data?.responseEnum;

  if (responseEnum !== apiResponseTypeEnum.OPERATION_SUCCESS) {
    return Promise.reject({ responseEnum });
  }
});

export const apiAuthenticateUser = ({ payload }) => apiRequest({
  url: 'auth',
  method: 'POST',
  data: payload,
})
  .catch(() => {
  })
  .then((response) => {
    if (!response) {
      return Promise.reject({ responseEnum: apiResponseTypeEnum.MSISDN_NOT_EXIST });
    } else if (!response.data?.token) {
      return Promise.reject({ responseEnum: response?.data || apiResponseTypeEnum.SERVER_ERROR });
    }

    return { parsedData: response.data.token };
  });

export const apiRetrieveAuthUserSummary = () => apiRequest({
  url: 'user',
  method: 'GET',
}).then((response) => {
  if (!response?.data) {
    return Promise.reject({ responseEnum: apiResponseTypeEnum.SERVER_ERROR });
  }
});

export const apiRetrieveAuthUserLoginDetails = ({ payload }) => apiRequest({
  url: 'api/getUserLoginDetails',
  method: 'POST',
  data: payload,
}).then((response) => {
  const responseEnum = response?.data?.responseEnum;
  const responseData = response?.data?.data;
  const responseUserDTOData = responseData?.userDTO;

  if (responseEnum !== apiResponseTypeEnum.OPERATION_SUCCESS) {
    return Promise.reject({ responseEnum });
  } else if (!responseUserDTOData) {
    return Promise.reject({ responseEnum: 'EMPTY_DATA' });
  }

  return {
    parsedLevelUpData: {
      levelUp: Boolean(responseData.levelUp),
      prizeValue: responseData.levelUpPoints || null,
    },
    parsedUserDTOData: {
      availableGames: responseUserDTOData.availableGames ?? 0,
      avatar: responseUserDTOData.avatar ?? '',
      gamesPlayed: responseUserDTOData.gamesPlayed ?? 0,
      email: responseUserDTOData.email ?? '',
      hasPrivateProfile: Boolean(responseUserDTOData.hasPrivateProfile),
      id: responseUserDTOData.id ?? null,
      jokersCheat: responseUserDTOData.jokersCheat ?? 0,
      jokersFifty: responseUserDTOData.jokersFifty ?? 0,
      language: responseUserDTOData.language ?? '',
      level: responseUserDTOData.level ?? 1,
      msisdn: responseUserDTOData.msisdn ?? '',
      operatorName: responseUserDTOData.operatorName ?? '',
      remainingPointsToLevel: responseUserDTOData.remainingPointsToLevel ?? 0,
      subscribed: Boolean(responseUserDTOData.subscribed),
      totalPointsEarned: responseUserDTOData.totalPointsEarned ?? 0,
      username: responseUserDTOData.username ?? '',
      webUser: Boolean(responseUserDTOData.webUser),
    },
  };
});

export const apiRetrieveAuthUserDetails = () => apiRequest({
  url: 'api/userDetails',
  method: 'GET',
}).then((response) => {
  const responseEnum = response?.data?.responseEnum;
  const responseData = response?.data?.data;

  if (responseEnum !== apiResponseTypeEnum.OPERATION_SUCCESS) {
    return Promise.reject({ responseEnum });
  } else if (!responseData) {
    return Promise.reject({ responseEnum: 'EMPTY_DATA' });
  }

  return {
    parsedData: {
      availableGames: responseData.availableGames ?? 0,
      avatar: responseData.avatar ?? '',
      avatarGender: responseData.avatarGender ?? null,
      displayAvatar: Boolean(responseData.displayAvatar),
      email: responseData.email ?? '',
      hasEmailVerified: Boolean(responseData.hasEmailVerified),
      hasPrivateProfile: Boolean(responseData.hasPrivateProfile),
      id: responseData.id ?? null,
      isUsernameUpdated: Boolean(responseData.usernameUpdated),
      language: responseData.lang ?? '',
      level: responseData.userLevel ?? 1,
      msisdn: responseData.msisdn ?? '',
      username: responseData.userId ?? '',
    },
  };
});

export const apiUpdateAuthUserLanguage = ({ language }) => apiRequest({
  url: 'api/updateLanguage',
  method: 'POST',
  params: { lang: language },
  data: { language },
}).catch(() => apiResponseTypeEnum.SERVER_ERROR);

export const apiRetrieveUserAchievements = async ({ msisdn = '' } = {}) => {
  const headers = {};

  if (msisdn) {
    headers['Rank-Msisdn'] = msisdn;
  }

  const response = await apiRequest({
    url: 'api/fetchUserAchievements',
    method: 'GET',
    headers,
  });

  const responseEnum = response?.data?.responseEnum;
  const responseData = response?.data?.data;


  if (responseEnum !== apiResponseTypeEnum.OPERATION_SUCCESS) {
    return Promise.reject({ responseEnum });
  } else if (!responseData || !Array.isArray(responseData.achievementCategoryDTOs)) {
    return Promise.reject({ responseEnum: 'EMPTY_DATA' });
  }

  const categoryList = Object.values(achievementCategoryEnum);

  const sortConfiguration = {
    [achievementCategoryEnum.PLAYED_GAMES]: 1,
    [achievementCategoryEnum.CORRECT_ANSWERS]: 2,
    [achievementCategoryEnum.SUCCESSFUL_FRIEND_INVITATIONS]: 3,
    [achievementCategoryEnum.STREAK_DAYS]: 4,
  };

  const achievementList = responseData.achievementCategoryDTOs
    .map(({ achievementDTOs }) => achievementDTOs)
    .flat()
    .filter(({ achievementName }) => categoryList.includes(achievementName))
    .toSorted((a, b) => sortConfiguration[a.achievementName] - sortConfiguration[b.achievementName])
    .map(({ achievementName, achievementLevelDTOs }) => achievementLevelDTOs.map((info) => ({
        achievementName: info.achievementLevelName,
        detailsList: [info],
        __category: achievementName,
      })),
    )
    .flat();

  return {
    parsedData: {
      achievementList,
      totalUnlockedAchievements: responseData.totalNumberOfAchievements || 0,
    },
  };
};

export const apiRetrieveUserStatistics = async ({ msisdn = '' } = {}) => {
  const headers = {};

  if (msisdn) {
    headers['Rank-Msisdn'] = msisdn;
  }

  const response = await apiRequest({
    url: 'api/getUserIconsGameStats',
    method: 'GET',
    headers,
  });

  if (!response?.data) {
    return Promise.reject({ responseEnum: apiResponseTypeEnum.SERVER_ERROR });
  }

  return {
    parsedData: {
      questionsPlayed: response.data.questionsPlayed ?? 0,
      correctQuestions: response.data.correctQuestions ?? 0,
      perfectGames: response.data.perfectGames ?? 0,
    },
  };
};

export const apiChangeUserProfileVisibility = ({ queryParams }) => apiRequest({
  url: 'api/toggleProfileVisibility',
  method: 'GET',
  params: queryParams,
}).then((response) => {
  const responseEnum = response?.data?.responseEnum;

  if (responseEnum !== apiResponseTypeEnum.OPERATION_SUCCESS) {
    return Promise.reject({ responseEnum });
  }
});

export const apiCheckUsernameAvailability = ({ queryParams }) => apiRequest({
  url: 'publicapi/checkUsername',
  method: 'GET',
  params: queryParams,
}).then((response) => {
  const message = response?.data?.data?.msg;
  const success = message === '';

  return {
    parsedData: {
      message,
      success,
      proposedUsername: response?.data?.data?.prpusn ?? '',
    },
  };
}).catch(() => ({ parsedData: { message: '', success: false, proposedUsername: '' } }));

export const apiChangeUsername = ({ queryParams }) => apiRequest({
  url: 'api/changeUsername',
  method: 'GET',
  params: queryParams,
}).then((response) => {
  const responseEnum = response?.data?.responseEnum;
  const data = response?.data?.data;

  if (responseEnum !== apiResponseTypeEnum.OPERATION_SUCCESS) {
    return Promise.reject({ responseEnum });
  } else if (!data) {
    return Promise.reject({ responseEnum: 'EMPTY_DATA' });
  }

  return {
    parsedData: data,
  };
});

export const apiChangePassword = ({ payload }) => apiRequest({
  url: 'api/changePassword',
  method: 'POST',
  data: payload,
}).then((response) => {
  const responseEnum = response?.data?.responseEnum;

  if (responseEnum !== apiResponseTypeEnum.OPERATION_SUCCESS) {
    return Promise.reject({ responseEnum });
  }
});

export const apiChangeAvatar = ({ payload }) => apiRequest({
  url: 'api/updateAvatar',
  method: 'POST',
  data: payload,
}).then((response) => {
  const responseEnum = response?.data?.responseEnum;

  if (responseEnum !== apiResponseTypeEnum.OPERATION_SUCCESS) {
    return Promise.reject({ responseEnum });
  }
});

export const apiChangeEmail = ({ queryParams }) => apiRequest({
  url: 'api/registerEmail',
  method: 'GET',
  params: queryParams,
}).then((response) => {
  const responseEnum = response?.data?.responseEnum;

  if (responseEnum !== apiResponseTypeEnum.OPERATION_SUCCESS) {
    return Promise.reject({ responseEnum });
  }
});

export const apiGetEmailVerificationStatus = ({ queryParams }) => apiRequest({
  url: 'api/validateEmail',
  method: 'GET',
  params: queryParams,
}).then((response) => ({
  isFirstTimeVerified: response?.data?.responseEnum === apiResponseTypeEnum.OPERATION_SUCCESS,
}));

export const apiRetrieveUserDetails = ({ msisdn }) => apiRequest({
  url: 'api/getUserDetails',
  method: 'GET',
  params: { msisdn },
}).then((response) => {
  const responseData = response?.data?.data;

  if (!responseData) {
    return Promise.reject({ responseEnum: 'EMPTY_DATA' });
  }

  return {
    parsedData: {
      username: responseData.username || '',
      availableGames: responseData.availableGames ?? 0,
      avatar: responseData.avatar ?? '',
      totalPointsEarned: responseData.totalPointsEarned ?? 0,
      level: responseData.level ?? 1,
      gamesToNextLevel: responseData.gamesToNextLevel ?? 0,
      gamesPlayed: responseData.gamesPlayed ?? 0,
    },
  };
}).catch((_e) => {
  return Promise.reject({ responseEnum: apiResponseTypeEnum.SERVER_ERROR });
});
